{
  "version": 1,
  "asset_id": "1aafa07d-e6be-46aa-937c-221bde719c8b",
  "project_id": "7580f3ab-e7a4-418d-abe6-5eb616986e51",
  "url": "/__l5e/assets-v1/1aafa07d-e6be-46aa-937c-221bde719c8b/lecanto-metal-roof-before-1200w.avif",
  "r2_key": "a/v1/7580f3ab-e7a4-418d-abe6-5eb616986e51/1aafa07d-e6be-46aa-937c-221bde719c8b/lecanto-metal-roof-before-1200w.avif",
  "original_filename": "lecanto-metal-roof-before-1200w.avif",
  "size": 139452,
  "content_type": "image/avif",
  "created_at": "2026-07-21T19:37:47Z"
}
